import React, { useEffect, useState, useRef } from "react";
import {
  Col,
  Row,
  Select,
  Input,
  Button,
  DatePicker,
  Form,
  InputNumber,
  Tabs,
} from "antd";
import { useTranslation } from "react-i18next";
import { noWhitespace, whiteSpace } from "../../../utils/rules";
import { notify } from "../../../redux/actions";
import aictia from "../../../const/api";
import moment from "moment";
import { connect } from "react-redux";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";

import { Link } from "react-router-dom";
import JoditEditor from "jodit-react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import history from "../../../const/history";
import { UsergroupAddOutlined } from "@ant-design/icons";
import Company from "../../Tabs/company/company";
import View from "../Register/view";
import Project from "../Portfolio/Tabs/project/project";
import Innovation from "../Portfolio/Tabs/innovation/innovation";
import Startup from "../Portfolio/Tabs/startup/startup";
import Invention from "../Portfolio/Tabs/invention/invention";
import Product from "../Portfolio/Tabs/product/product";
import { useLocation, useHistory } from "react-router-dom";
import queryString from "query-string";

const { Option } = Select;


const CreatePortfolio = (props) => {
  const { t } = useTranslation();

  const [text, setText] = useState({});
  const { id } = useParams();

  const formRef = useRef();
  const { TabPane } = Tabs;
  const location = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(location.search);
  const page = location.state?.page || 1;
  const view = window.location.hash.includes("view") ? true : false;
  const activeTab = params.get("tab") || "1";

  const handleTabChange = (key) => {
    const newParams = new URLSearchParams(location.search);
    newParams.set("tab", key);
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });
  };
  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <div className="border flex-between page-heading flex p-2 mt-0 bg-white">
            <div className="page-name">
              <UsergroupAddOutlined className="f-20 mr5-15" />
              <span className="f-20 bold">
                {t('companyInfo')}
              </span>
            </div>
            <Link
              to={{
                pathname: `/portfolio`,
                state: { page: page }
              }}
            >
              <Button type={"primary"}>X</Button>
            </Link>
          </div>
        </Col>
        <Col xs={24}>
          <Tabs activeKey={activeTab} onChange={handleTabChange}>
            {(!id && !view || activeTab == 1) && (
              <TabPane tab={"Layihə"} key={"1"}>
                <div className={`p-4 animated edit fadeInUp bg-white`}>
                  <Project id={id} view={view} />
                </div>
              </TabPane>
            )}
            {(!id && !view || activeTab == 2) && (
              <TabPane tab={"İnnovasiya"} key={"2"}>
                <div className={`p-4 animated edit fadeInUp bg-white `}>
                  <Innovation id={id} view={view} />
                </div>
              </TabPane>
            )}
            {(!id && !view || activeTab == 3) && (
              <TabPane tab={"Startup"} key={"3"}>
                <div className={`p-4 animated edit fadeInUp bg-white `}>
                  <Startup id={id} view={view} />
                </div>
              </TabPane>
            )}

            {(!id && !view || activeTab == 4) && (
              <TabPane tab={"İxtira"} key={"4"}>
                <div className={`p-4 animated edit fadeInUp bg-white `}>
                  <Invention id={id} view={view} />
                </div>
              </TabPane>
            )}

            {(!id && !view || activeTab == 5) && (
              <TabPane tab={"Məhsul"} key={"5"}>
                <div className={`p-4 animated edit fadeInUp bg-white `}>
                  <Product id={id} view={view} />
                </div>
              </TabPane>
            )}
          </Tabs>
        </Col>
      </Row>
    </div>
  );
};

export default connect(null, { notify })(CreatePortfolio);

